document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('klaviyo-popup');

  if (!popup) return;

  const form = document.getElementById('klaviyo-popup-form');
  const emailInput = document.getElementById('klaviyo-popup-email');
  const errorMessage = document.getElementById('klaviyo-popup-error');

  const formState = popup.querySelector('.klaviyo-popup__form-state');
  const successState = popup.querySelector('.klaviyo-popup__success-state');
  const submitButton = popup.querySelector('.klaviyo-popup__submit');

  const closeButtons = popup.querySelectorAll('[data-klaviyo-close]');

  const companyId = popup.dataset.companyId;
  const listId = popup.dataset.listId;

  const DISMISS_KEY = 'gregross_klaviyo_dismissed_at';
  const SUBSCRIBED_KEY = 'gregross_klaviyo_subscribed';

  const DISMISS_DURATION = 7 * 24 * 60 * 60 * 1000;

  let previouslyFocusedElement = null;

  function hasRecentlyDismissed() {
    const dismissedAt = localStorage.getItem(DISMISS_KEY);

    if (!dismissedAt) return false;

    return Date.now() - Number(dismissedAt) < DISMISS_DURATION;
  }

  function hasSubscribed() {
    return localStorage.getItem(SUBSCRIBED_KEY) === 'true';
  }

  function openPopup() {
    previouslyFocusedElement = document.activeElement;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');

    document.body.classList.add('klaviyo-popup-open');

    setTimeout(() => {
      emailInput?.focus();
    }, 200);
  }

  function closePopup(rememberDismissal = true) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('klaviyo-popup-open');

    if (rememberDismissal) {
      localStorage.setItem(DISMISS_KEY, Date.now().toString());
    }

    previouslyFocusedElement?.focus();
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      closePopup(true);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup(true);
    }
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();

    const email = emailInput.value.trim();

    if (!email) return;

    errorMessage.hidden = true;
    errorMessage.textContent = '';

    submitButton.disabled = true;
    submitButton.textContent = 'SIGNING UP...';

    const payload = {
      data: {
        type: 'subscription',

        attributes: {
          custom_source: 'Greg Ross homepage popup',

          profile: {
            data: {
              type: 'profile',

              attributes: {
                email: email,

                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },

        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },

          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error(`Klaviyo returned ${response.status}`);
      }

      localStorage.setItem(SUBSCRIBED_KEY, 'true');
      localStorage.removeItem(DISMISS_KEY);

      formState.hidden = true;
      successState.hidden = false;

      setTimeout(() => {
        closePopup(false);
      }, 1800);
    } catch (error) {
      console.error('Klaviyo signup error:', error);

      errorMessage.textContent =
        'Something went wrong. Please try again.';

      errorMessage.hidden = false;
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'SIGN UP';
    }
  });

  if (!hasSubscribed() && !hasRecentlyDismissed()) {
    setTimeout(() => {
      openPopup();
    }, 1500);
  }
});